import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isPdfButtonVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('pdf'),
)

export default isPdfButtonVisibleSelector
